import { CreateAlertRequest, ReadAlertsRequest } from "@/types/alert";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { QUERY_KEYS } from "../queryKeys";
import { createAlert, readAlerts } from "@/services/api/alert";

// 알림 생성
export const useCreateAlert = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateAlertRequest) => createAlert(data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: QUERY_KEYS.ALERT.LIST,
      });
    },
  });
};

// 사용자 알림 목록 조회
export const useReadAlerts = ({ limit, offset }: ReadAlertsRequest) => {
  return useQuery({
    queryKey: QUERY_KEYS.ALERT.LIST,
    queryFn: () => readAlerts({ limit, offset }),
  });
};
